import { Pipe, PipeTransform } from '@angular/core';

import { Product } from 'idt-ecommerce-api/catalog/products/products.models';


@Pipe({
  name: 'isCurrentPriceOnSale'
})
export class IsCurrentPriceOnSalePipe implements PipeTransform {

  public transform(product: Product, displayOldProductPrices: boolean): boolean {
    const hasOldPrice = !!product.priceInfo?.oldPriceWithCurrencySymbol;
    return displayOldProductPrices && hasOldPrice;
  }

}
